import { configConstants as sess } from "../../../constants/configs";

const initialState = {
  loading: true,
  list: [],
  data: null,
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case sess.GET_SESSIONS:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case sess.SET_LOAD:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
